export class FileUtils {

  static saveBlobAsFile(filename: string, blob: any): void {
    if (blob) {
      const nav = window.navigator as any;
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blob, filename);
      } else {
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        document.body.removeChild(a);
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 0);
      }
    }
  }

  static getFilenameFromContentDisposition(header: string | null): string | null {
    if (!header) {
      return null;
    }

    const filenameStarMatch = header.match(/filename\*\s*=\s*([^;]+)/i);
    if (filenameStarMatch?.[1]) {
      const value = filenameStarMatch[1].trim();
      const parts = value.split("''");
      if (parts.length === 2) {
        try {
          return decodeURIComponent(parts[1].replace(/^["']|["']$/g, ""));
        } catch {
          return parts[1].replace(/^["']|["']$/g, "");
        }
      }
    }

    const filenameMatch = header.match(/filename\s*=\s*([^;]+)/i);
    if (filenameMatch?.[1]) {
      return filenameMatch[1].trim().replace(/^["']|["']$/g, "");
    }

    return null;
  }
}